import { render } from "./company-logo-03-black.svg?vue&type=template&id=0c87c8c5"
const script = {}
script.render = render

export default script